export default "__VITE_ASSET__9ylk0fYi__"